import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGenderMale: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGenderMale"><Path fillRule="evenodd" clipRule="evenodd" d="M14 3H21V10H19.5V5.56066L14.096 10.9647C14.975 12.0732 15.5 13.4753 15.5 15C15.5 18.5899 12.5899 21.5 9 21.5C5.41015 21.5 2.5 18.5899 2.5 15C2.5 11.4101 5.41015 8.5 9 8.5C10.5247 8.5 11.9268 9.02496 13.0353 9.90399L18.4393 4.5H14V3ZM9 10C6.23858 10 4 12.2386 4 15C4 17.7614 6.23858 20 9 20C11.7614 20 14 17.7614 14 15C14 12.2386 11.7614 10 9 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGenderMale;
